import { styled } from "@mui/material/styles";
import React from "react";
import ViewChatImagesModal from "../../../modals/ViewChatImagesModal";
const StackContainer = styled("div")({
	display: "flex",
	flexWrap: "wrap",
	gap: "2px",
	maxWidth: "280px",
	borderRadius: "16px",
	overflow: "hidden",
});

const ImageWrapper = styled("div")({
	position: "relative",
	width: "100%",
	height: "100%",
});
const GridImage = styled("img")({
	objectFit: "cover",
	borderRadius: "0",
	"&.single": {
		width: "180px",
		height: "180px",
	},
	"&.double": {
		width: "139px",
		height: "180px",
	},
	"&.triple": {
		"&.large": {
			width: "280px",
			height: "186px",
		},
		"&.small": {
			width: "139px",
			height: "92px",
		},
	},
	"&.quad": {
		width: "139px",
		height: "139px",
	},
});

const ImageStack = ({ images }: { images: string[] }) => {
	const [openModal, setOpenModal] = React.useState(false);
	const handleOpenModal = () => {
		setOpenModal(true);
	};
	const handleCloseModal = () => {
		setOpenModal(false);
	};
	const renderImageGrid = () => {
		switch (images.length) {
			case 1:
				return (
					<StackContainer>
						<GridImage
							src={images[0] as string}
							alt="preview-0"
							className="single"
							onClick={handleOpenModal}
						/>
					</StackContainer>
				);

			case 2:
				return (
					<StackContainer>
						{images.map((src, index) => (
							<GridImage
								key={index}
								src={src}
								alt={`preview-${index}`}
								className="double"
								onClick={handleOpenModal}
								style={{ cursor: "pointer" }}
							/>
						))}
					</StackContainer>
				);

			case 3:
				return (
					<StackContainer>
						<GridImage
							src={images[0]}
							alt="preview-0"
							className="triple large"
						/>
						<div style={{ display: "flex", gap: "2px" }}>
							{images.slice(1).map((src, index) => (
								<GridImage
									key={index + 1}
									src={src}
									alt={`preview-${index + 1}`}
									className="triple small"
									onClick={handleOpenModal}
									style={{ cursor: "pointer" }}
								/>
							))}
						</div>
					</StackContainer>
				);

			default:
				return (
					<StackContainer>
						<div
							style={{ display: "flex", gap: "2px", cursor: "pointer" }}
							onClick={handleOpenModal}
						>
							<GridImage
								src={images[0]}
								alt="preview-0"
								className="quad"
							/>
							<GridImage
								src={images[1]}
								alt="preview-1"
								className="quad"
							/>
						</div>
						<div
							style={{ display: "flex", gap: "2px", cursor: "pointer" }}
							onClick={handleOpenModal}
						>
							<GridImage
								src={images[2]}
								alt="preview-2"
								className="quad"
							/>
							<ImageWrapper
								sx={{
									position: "relative",
									width: "139px",
									height: "139px",
									overflow: "hidden",
									cursor: "pointer",
								}}
							>
								<GridImage
									src={images[3]}
									alt="preview-3"
									className="quad"
									onClick={handleOpenModal}
									style={{ cursor: "pointer" }}
								/>
								{images.length > 4 && (
									<div
										style={{
											position: "absolute",
											top: 0,
											left: 0,
											right: 0,
											bottom: 0,
											background: "rgba(0,0,0,0.5)",
											color: "white",
											display: "flex",
											alignItems: "center",
											justifyContent: "center",
											fontSize: "16px",
											fontWeight: "bold",
											cursor: "pointer",
										}}
										onClick={handleOpenModal}
									>
										+{images.length - 4}
									</div>
								)}
							</ImageWrapper>
						</div>
					</StackContainer>
				);
		}
	};

	return (
		<>
			<ViewChatImagesModal
				open={openModal}
				handleClose={handleCloseModal}
				allImages={images}

			/>
			{renderImageGrid()}
		</>
	);
};

export default ImageStack;
